import { render, staticRenderFns } from "./KarmaRequestList.vue?vue&type=template&id=b6a5c416&scoped=true&"
import script from "./KarmaRequestList.vue?vue&type=script&lang=js&"
export * from "./KarmaRequestList.vue?vue&type=script&lang=js&"
import style0 from "./KarmaRequestList.vue?vue&type=style&index=0&id=b6a5c416&lang=scss&scoped=true&"
import style1 from "./KarmaRequestList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a5c416",
  null
  
)

export default component.exports